'use client'
import { useInfiniteQuery } from '@tanstack/react-query'
import useTranslation from 'next-translate/useTranslation'
import InfiniteScroll from 'react-infinite-scroll-component'

import Loader from '@/components/Loader'
import PostDetailsComp from '@/components/PostDetails'

import { api } from '@/services/api'

import { PostDetails } from '@/types'

function MorePosts({ postIdToIgnore, userId = null }) {
  const { t } = useTranslation()

  // console.log(`moreposts ${new Date()} ===== `, startPage)

  const postListQuery = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['post_list'],
    queryFn: async (options) => {
      const { pageParam } = options
      // debugger
      const res = await api.getLatestPosts<{ data: PostDetails[] }>(pageParam, 10, userId)

      if (res.kind === 'ok') {
        return res.data
      }

      return []
    },
    getNextPageParam: (latestPage: { meta: { currentPage: number; lastPage: number } }) => {
      // if (!latestPage) {
      //   return undefined
      // }

      const currentPage = latestPage.meta.currentPage || 1
      const lastPage = latestPage.meta.lastPage || 1
      const nextPage = currentPage + 1
      return nextPage <= lastPage ? nextPage : undefined
    },

    // staleTime: 1000 * 60 * 60,
  })

  let postListData: PostDetails[] = []

  if (postListQuery?.data?.pages) {
    for (const page of postListQuery.data.pages) {
      // postListData = postListData.concat(page.data)
      postListData = postListData.concat(page.data.filter((p) => p.id != postIdToIgnore))
    }
  }

  return (
    <div>
      <InfiniteScroll
        dataLength={postListData.length}
        next={postListQuery.fetchNextPage}
        hasMore={postListQuery.hasNextPage} // Replace with a condition based on your data source
        loader={
          <div className="flex h-40 w-full items-center justify-center">
            <Loader />
          </div>
        }
        // endMessage={<p>end======</p>}
      >
        {postListData.map((post, index) => {
          return <PostDetailsComp key={`post-${index}`} post={post} expand={false} />
        })}
      </InfiniteScroll>
    </div>
  )
}

export default MorePosts
